import environment from "@/environment";
import * as userService from "./userService";
import axios from "axios";

const axiosInstance = axios.create({
  // baseURL: "https://"+window.location.host+"/api/v1",
  baseURL: environment.apiBaseUrl,
  headers: {
    "accept-language": localStorage.getItem("vue-i18n-locale") || "vi",
    "content-language": localStorage.getItem("vue-i18n-locale") || "vi",
    // "x-accept-language": localStorage.getItem("vue-i18n-locale") || "vi",
  }
});
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status == 401) {
      setTimeout(()=>{
        userService.signOut();
      }, 2000);
    }
    return Promise.reject(error);
  }
);


export { axiosInstance };